export const formatPercentage = (value) => {
  if (!value && value !== 0) return "0";
  console.info("value => ", value);

  const formatted = parseFloat(value).toFixed(2);
  return formatted.endsWith(".00") ? formatted.slice(0, -3) : formatted;
};
